module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-tired.efd9296f.png";